module.exports = __webpack_public_path__ + "img/b2slip.0f448386.png";